export default "__VITE_ASSET__7469bfd6__"